import { categories } from "@/mocks/gua";

export default function CategoryMap() {
  return (
    <section id="map" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-200 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-map-2-line"></i>瓜田地图
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              按圈层，找到你的瓜
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              不同圈层的话题密度不同、发酵方式也各异。按你关心的圈层点进来，
              每一块瓜田都标注了当前追踪中的热点数量。
            </p>
          </div>
          <a
            href="#hot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            看实时热度榜<i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => (
            <a
              key={cat.title}
              href="#feed"
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-100 text-primary-500 transition-colors group-hover:bg-primary-100">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-700">
                  {cat.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{cat.title}</h3>
              <p className="mt-1.5 text-sm leading-6 text-foreground-600">{cat.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
                <span>追踪中 {cat.count} 只瓜</span>
                <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}